import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadCheckTypesListBegin, loadCheckTypesListFailed, loadCheckTypesListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';
import { LOADING_DELAY } from '../../System/constants';

export default function* loadCheckTypesList(action) {
  try {
    const {
      payload = {
      },
    } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
      sort,
    } = payload;
    let pool = {
      limit,
      page,
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(filter, pool);
    }
    if (typeof sort === 'string' && sort.length) {
      pool = { ...pool, sort };
    }
    const url = `${BACKEND_URL}/resources/check-types`;
    yield put(loadCheckTypesListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadCheckTypesListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadCheckTypesListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    // yield put(loadCheckTypesListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
